import { Button, Offcanvas } from 'react-bootstrap';
import { X, Plus } from 'lucide-react';
import { ProductPageSectionType } from '@/backend/access/productPageSection/types';
import { useProductPageStore } from '@/frontend/store/ProductPageStore';
import { I18n } from '@/i18n/I18n';
import { ProductPageSectionEditor } from './ProductPageSectionEditor';

interface ProductPageEditorProps {
  onHide: () => void;
  procedureInstanceId: string;
  type: ProductPageSectionType;
}

export function ProductPageEditor({
  onHide,
  procedureInstanceId,
  type,
}: ProductPageEditorProps) {
  const { createSection } = useProductPageStore();
  const sections = useProductPageStore(state => state.sections);

  const handleAddSection = () => {
    void createSection({
      procedureInstanceId,
      title: '',
      description: '',
      position: sections.length,
      type,
    });
  };

  return (
    <Offcanvas
      show
      onHide={onHide}
      placement="end"
      className="side-panel"
      backdrop={false}
      scroll
    >
      <Offcanvas.Body className="side-panel-container">
        <div>
          <button
            type="button"
            className="btn btn-sm btn-blue-light"
            onClick={onHide}
            aria-label={I18n.get('close')}
          >
            <X size={20} />
          </button>
          <h4 className="panel-heading my-4">{I18n.get('editProductPage', { type: type === ProductPageSectionType.TEMPLATE ? I18n.get('Template') : I18n.get('Procedure') })}</h4>
        </div>
        <div>
        <div className='d-flex flex-column gap-2'>
          {sections.map((section) => (
            <ProductPageSectionEditor
              key={section.id}
              section={section}
            />
          ))}
        </div>
        <div className="text-center mt-3 mb-4">
          <Button
            variant="primary"
            className="fusa-btn-medium-with-icon"
            onClick={handleAddSection}
          >
            <Plus size={20} />
            {I18n.get('addNewSection')}
          </Button>
        </div>
      </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
}
